import { useState } from 'react';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { getCmsUrl } from 'helpers';
import SubscribeToNewsLetterLarge from './SubscribeToNewsLetterLarge';
import SubscribeToNewsLetterSmall from './SubscribeToNewsLetterSmall';

const components = {
  lg: SubscribeToNewsLetterLarge,
  sm: SubscribeToNewsLetterSmall
};

export default function SubscribeToNewsLetter ({
  className = '',
  size = 'lg'
}) {
  const { t } = useTranslation('common');
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [isSubmitted, setIsSubmitted] = useState(false);

  const initialValues = {
    email: '',
  };

  const validationSchema = Yup.object().shape({
      email: Yup.string().email(t('invalid_email', { ns: 'validation' })).required(t('required', { ns: 'validation' })),
  });

  const onSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const response = await fetch(`${getCmsUrl()}/api/newsletter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(values),
      });

      const json = await response.json();

      dispatchEvent(new CustomEvent('alert', {
        detail: {
          type: 'success',
          message: json.message || t('message.thank_you_for_subscribing'),
        }
      }))

      resetForm();
      // setIsSubmitted(false);
    } catch (error) {
      console.error('Error:', error);

      dispatchEvent(new CustomEvent('alert', {
        detail: {
          type: 'error',
          message: error.message || t('message.subscribing_error_occured'),
        }
      }))
    }
    setIsSubmitting(false);
  };

  const FormComponent = components[size] || components.lg;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({
        touched,
        errors,
        handleBlur,
        values,
        handleChange
      }) => (
        <div className="relative z-10">
          <Form>
            <FormComponent
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              values={values}
              // isSubmitted={isSubmitted}
              isSubmitting={isSubmitting}
              className={className}
            />
          </Form>
        </div>
      )}
    </Formik>
  )
}
